import { useEffect } from 'react';

import {
  CHAT_IMAGE_OPEN_EVENT,
  readChatImageOpen,
} from '../../../blocksuite/utils/chat-image-open';
import type { PeekViewEntity } from '../entities/peek-view';
import type { ImageData } from './image-preview';

function chatImageData(images: string[], index: number): ImageData {
  return {
    index,
    url: images[index],
    previous: index > 0 ? () => chatImageData(images, index - 1) : undefined,
    next:
      index < images.length - 1
        ? () => chatImageData(images, index + 1)
        : undefined,
  };
}

/** Opens chat images in the animated fullscreen image viewer. */
export function useChatImageOpen(peekView: PeekViewEntity) {
  useEffect(() => {
    const handler = (event: Event) => {
      const detail = readChatImageOpen(event);
      if (!detail) return;
      peekView
        .open({
          type: 'image-list',
          data: {
            image: chatImageData(detail.images, detail.index),
            total: detail.images.length,
          },
        })
        .catch(console.error);
    };
    window.addEventListener(CHAT_IMAGE_OPEN_EVENT, handler);
    return () => window.removeEventListener(CHAT_IMAGE_OPEN_EVENT, handler);
  }, [peekView]);
}
